import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { checkAndStoreAuthFromURL } from '../utils/appNavigation';

/**
 * Higher-order component that checks for auth tokens in URL
 * and stores them BEFORE rendering the app
 */
const AuthWrapper = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      // Check and store tokens from URL if present
      const hasTokensInURL = checkAndStoreAuthFromURL();

      // If tokens were in URL, wait a moment to ensure localStorage is fully written
      if (hasTokensInURL) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Mark as ready to render the app
      setIsReady(true);
    };

    initializeAuth();
  }, []);

  // Don't render children until tokens are processed
  if (!isReady) {
    return null;
  }

  return children;
};

AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthWrapper;
